import { injectable, inject } from "inversify";
import { ActivitySummary } from "@project/domain/models/activity-summary.model";
import { type Http } from "@core/data/infrastructures/http/http";
import { coreTypes } from "@core/core-types.di";
import { Either } from "@core/domain/types/either";
import { HttpError } from "@core/data/infrastructures/http/errors/http.error";


@injectable()
export class ActivityDatasource {
    constructor(
        @inject(coreTypes.infrastructure.Http)
        private readonly http: Http,
    ) { }

    async fetchByIds(ids: number[]): Promise<Either<HttpError, ActivitySummary[]>> {
        // Formato más compatible con DRF: id__in=1,2,3
        const queryString = `id__in=${ids.join(',')}`;

        const response = await this.http.get<{ results: ActivitySummary[] }>(
            `/technical_proposals_activities/?${queryString}`
        );

        // Extraer solo el array results de la respuesta
        return response.map(httpResponse => httpResponse.data.results);
    }
}